import { STATUS, STATUS_TAKE, STATUS_IN_DELIVERY, TAKE_AWAY, DELIVERY, VOUCHER } from './constants';

class Status {
  static getStatusByOrderType(orderType) {
    const status = STATUS.slice(2, STATUS.length);

    switch (orderType) {
      case TAKE_AWAY:
        return status.filter(item => item.id !== STATUS_IN_DELIVERY);
      case DELIVERY:
        return status.filter(item => item.id !== STATUS_TAKE);
      case VOUCHER:
        return status.filter(item => item.id !== STATUS_IN_DELIVERY);
      default:
        return status;
    }
  }

  static addDotInformation(status) {
    return {
      ...status,
      dot: {
        borderColor: status.borderColor ? status.borderColor : status.bgColor,
        color: status.bgColor,
      },
    };
  }
}

export default Status;



// WEBPACK FOOTER //
// ./src/helpers/status.js